// extracted by mini-css-extract-plugin
export default {"tiles":"FinanceType_tiles__HBBgd","link":"FinanceType_link__qxgy5","ctaContainer":"FinanceType_ctaContainer__nJlMo","typeHeading":"FinanceType_typeHeading__P6x+v"};